import { AvatarCanvas } from './AvatarCanvas'

export function AvatarStage({ stage, voiceActive, layout = 'focus' }) {
  return (
    <div className={`avatar-stage is-${stage} layout-${layout}`}>
      <div className="avatar-model-core">
        <div className={`voice-aura ${voiceActive ? 'on' : ''}`} />
        <div className={`wave-ring ${voiceActive ? 'on' : ''}`}>
          <i /><i /><i /><i /><i /><i /><i />
        </div>
        <AvatarCanvas />
      </div>
    </div>
  )
}
